
import tools5eToDmBMapper from './mappers/5eToDmBMapper';
import tools5eObjectToDmBMapper from './mappers/5eObjectToDmBMapper';

import GlobalImg from './pics/global.png'
import axios from 'axios';

import aid from './pics/effects/aid.png'; 
import bane from './pics/effects/bane.png'; 
import bladeWard from './pics/effects/bladeWard.png'; 
import bless from './pics/effects/bless.png'; 
import blinded from './pics/effects/blinded.png'; 
import boneChilled from './pics/effects/boneChilled.png'; 
import barkSkin from './pics/effects/barkSkin.png'; 
import command from './pics/effects/command.png'; 
import confused from './pics/effects/confused.png'; 
import disguised from './pics/effects/disguised.png'; 
import ensnared from './pics/effects/ensnared.png'; 
import faerieFire from './pics/effects/faireFire.png'; 
import guidance from './pics/effects/guidance.png'; 
import guidingBolt from './pics/effects/guidingBolt.png'; 
import hex from './pics/effects/hex.png'; 
import holdPerson from './pics/effects/holdPerson.png'; 
import huntersMark from './pics/effects/huntersMark.png'; 
import invis from './pics/effects/invis.png'; 
import poisoned from './pics/effects/poisoned.png'; 
import rayOfFrost from './pics/effects/rayOfFrost.png'; 
import sheildOfFaith from './pics/effects/sheildOfFaith.png'; 
import silence from './pics/effects/silence.png'; 
import slept from './pics/effects/slept.png'; 
import webbed from './pics/effects/webbed.png'; 

import blindedCondition from './pics/conditions/blinded.png'; 
import charmed from './pics/conditions/charmed_o.png'; 
import deafened from './pics/conditions/deafened.png'; 
import frightened from './pics/conditions/frightened.png'; 
// import Exhaustion from './pics/conditions/aided_o.png'; 
// import Grappled from './pics/conditions/aided_o.png'; 
import incapacitated from './pics/conditions/incapacitated.png'; 
import invisibleCondition from './pics/conditions/invisible.png'; 
import paralyzed from './pics/conditions/paralyzed.png'; 
import petrified from './pics/conditions/petrified.png'; 
import poisonedCondition from './pics/conditions/poison.png'; 
// import Prone from './pics/conditions/prone.png'; 
// import Restrained from './pics/conditions/Restrained.png'; 
import stunned from './pics/conditions/stunned.png'; 
import unconscious from './pics/conditions/unconcious.png'; 

import background1 from "./pics/backgrounds/fallenCastleBigTree.jpg"
import background2 from "./pics/backgrounds/spookyForest.jpg"
import background3 from "./pics/backgrounds/grasslands.jpg"
import background4 from "./pics/backgrounds/lavaMontains.jpg"
import background5 from "./pics/backgrounds/riverPath.jpg"
import background6 from "./pics/backgrounds/riverVillage.jpeg"
import background7 from "./pics/backgrounds/shiningTown.jpg"
import background8 from "./pics/backgrounds/snowyForrest.jpg"
import background9 from "./pics/backgrounds/snowyMounts.jpg"
import background10 from "./pics/backgrounds/spookyCastle.jpg"
import background11 from "./pics/backgrounds/spookyVillage.jpg"
import background12 from "./pics/backgrounds/snowyMountsGiant.jpg"
import background13 from "./pics/backgrounds/happyTavern.png"
import background14 from "./pics/backgrounds/tavern.jpg"
import background15 from "./pics/backgrounds/dungeon.jpg"
import background16 from "./pics/backgrounds/waterfall.gif"
import background17 from "./pics/backgrounds/faireSwamp.gif"
import background18 from "./pics/backgrounds/tower.gif"
import background19 from "./pics/backgrounds/butteflyCavern.gif"
import background20 from "./pics/backgrounds/riverDeer.gif"
import background21 from "./pics/backgrounds/grass.gif"
import background22 from "./pics/backgrounds/church.gif"
import background23 from "./pics/backgrounds/adventureTime.gif"
import background24 from "./pics/backgrounds/fire.gif"
import objectImage from './pics/objectImage.jpg';

import adventureNamesJson from "./jsons/adventures/adventures.json"

import conditionsJson from "./jsons/conditions/conditions.json"
import traitsAndActions from "./jsons/homebrew/traitsAndActions.json"
import extraTraits from "./jsons/homebrew/monsterfeatures.json"

import books from "./jsons/books.json"

export const exportHomebrewActions = traitsAndActions.makebrewCreatureAction
export const exportHomebrewTraits = [...traitsAndActions.makebrewCreatureTrait, ...extraTraits.monsterfeatures.map(f => {return {name: f.name + ' [' + f.example + ']', entries: [f.effect]}})].sort((a, b) => {
    return a.name.localeCompare(b.name);
});

export const sortEncounters = (encounters) => {
    encounters.sort((a, b) => {
        return a.encounterName.localeCompare(b.encounterName);
    });
}

// Load all JSONs into an object
const creatureJsonModules = require.context('./jsons/5eCreatures', true, /\.json$/);
const allJsonData = creatureJsonModules.keys().map(key => creatureJsonModules(key).monster);

const bookJsonModules = require.context('./jsons/adventures/adventureData', true, /\.json$/);
export const allBookData = bookJsonModules.keys().map(key => bookJsonModules(key));
export const adventureNamesExport = adventureNamesJson.adventure.sort((a, b) => {
    const aIsOpen = localStorage.getItem(`book-${a.id}`);
    const bIsOpen = localStorage.getItem(`book-${b.id}`);
    
    // If one is open and the other isn't, open one comes first
    if (aIsOpen && !bIsOpen) return -1;
    if (!aIsOpen && bIsOpen) return 1;
    
    // If both have same open status, sort alphabetically by name
    return a.name.localeCompare(b.name);
});
const spellModules = require.context('./jsons/spells', false, /\.json$/);
const allSpells = spellModules.keys().map(key => spellModules(key).spell);

export const bookOptions = books.book.reduce((arr, book) => {
    if (book.name && book.source) {
        arr.push(`${book.name} - ${book.source}`);
    }

    arr.sort((a,b) => {
        return a.localeCompare(b)
    })

    return arr;
}, []);

export const spellCastingOptions = ["Spellcasting", "No Spellcasting"]

const sortBySource = (arr) => {
    arr.sort((a, b) => {
        // Move 'XPHB' sources to the top
        if (a.source === 'XPHB' && b.source !== 'XPHB') {
            return -1; // a comes first
        }
        if (a.source !== 'XPHB' && b.source === 'XPHB') {
            return 1; // b comes first
        }
        // If sources are the same or neither is 'XPHB', sort alphabetically by name
        return a.name.localeCompare(b.name);
    });
}

export const sortByIsPlayer = (arr) => {
    return arr.sort((a, b) => {
        // Move 'XPHB' sources to the top
        if (a.type === "monster" && b.type !== "monster") {
            return -1; // a comes first
        } else if(a.type !== "monster" && b.type === "monster") {
            return 1
        } else {
            return a.name.localeCompare(b.name)
        }
    });
}

let spells = []
allSpells.forEach(spellList => {
    spells.push(...spellList)
});

sortBySource(spells)
sortBySource(conditionsJson.condition)
sortBySource(conditionsJson.disease)
sortBySource(conditionsJson.status)

export const exportSpells = spells
export const exportSpellsShuffled = shuffleArray([...spells]);

let conditionsOptions = []
conditionsJson.condition.forEach(c => {
    if(c.source === 'XPHB') {
        conditionsOptions.push(c.name)
    }
})

export const sensesOptionsExport = [
    "Blindsight", "Darkvision", "Tremorsense", "Truesight",
]

export const damageTypeOptionsExport = [
    "Acid", "Cold", "Fire", "Force",
    "Lightning", "Necrotic", "Poison",
    "Psychic", "Radiant", "Thunder",
    "Piercing", "Slashing", "Bludgeoning",  
    "Piercing (Non-Magical)", "Slashing (Non-Magical)", "Bludgeoning (Non-Magical)",
]

export const conditionsOptionsExport = conditionsOptions

export const conditionsExport = conditionsJson.condition.map(c => {return {...c, objectType: 'condition'}})
export const diseasesExport = conditionsJson.disease.map(c => {return {...c, objectType: 'disease'}})
export const statusExport = conditionsJson.status.map(c => {return {...c, objectType: 'status'}})

export const allConditions = [...conditionsExport, ...diseasesExport, ...statusExport];
export const allConditionsShuffled = shuffleArray([...conditionsExport, ...diseasesExport, ...statusExport]);

export const COLOR_RED = "#D44E3B"
export const COLOR_GREEN = "#68AA33"

export const backgroundImages = [
    { imageGuid: "constant", image: background1 },
    { imageGuid: "constant", image: background2 },
    { imageGuid: "constant", image: background3 },
    { imageGuid: "constant", image: background4 },
    { imageGuid: "constant", image: background5 },
    { imageGuid: "constant", image: background6 },
    { imageGuid: "constant", image: background7 },
    { imageGuid: "constant", image: background8 },
    { imageGuid: "constant", image: background9 },
    { imageGuid: "constant", image: background10 },
    { imageGuid: "constant", image: background11 },
    { imageGuid: "constant", image: background12 },
    { imageGuid: "constant", image: background13 },
    { imageGuid: "constant", image: background14 },
    { imageGuid: "constant", image: background15 },
    { imageGuid: "constant", image: background16 },
    { imageGuid: "constant", image: background17 },
    { imageGuid: "constant", image: background18 },
    { imageGuid: "constant", image: background19 },
    { imageGuid: "constant", image: background20 },
    { imageGuid: "constant", image: background21 },
    { imageGuid: "constant", image: background22 },
    { imageGuid: "constant", image: background23 },
    { imageGuid: "constant", image: background24 }
];

export const sortCreatureArray = (array) => {
    return array.sort((a, b) => {
        const initiativeA = a.initiative;
        const initiativeB = b.initiative;

        if (initiativeA === null && initiativeB !== null) {
            return 1;
        } else if (initiativeA !== null && initiativeB === null) {
            return -1;
        } else if (initiativeA !== null && initiativeB !== null) {
            const initiativeComparison = Math.abs(initiativeB) - Math.abs(initiativeA);
            if (initiativeComparison !== 0) {
                return initiativeComparison;
            } else {
                return a.name.localeCompare(b.name);
            }
        } else {
            return 0;
        }
    });
};

const idValues = ['1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
export const generateUniqueId = () => {
    let s = '';
    while (s.length < 10) {
        s += idValues[Math.floor(Math.random() * 35)];
    }

    return s.toUpperCase();
};

export const addSign = (modNumber) => {
    //Catches 0 and null
    if (modNumber === "+")
        return ''

    if (typeof modNumber === 'string' && modNumber.includes('+')) {
        return modNumber
    }

    if (modNumber > 0) {
        return `+${modNumber}`
    }

    return `${modNumber}`; // Negative number already has a minus sign
}

export function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1)); // Random index from 0 to i
        [array[i], array[j]] = [array[j], array[i]]; // Swap elements
    }
    return array;
}

export const handleOpenSession = (sessionID, tv=false) => {
    if(!sessionID) {
        alert("Start a session first :)")
    }
    
    let url = window.location.href;
    // Add '/' if needed
    url += url.endsWith("/") ? "" : "/";
    // Opens a popup window so bookmakrs and tabs are auto hidden
    let popupUrl = `${url}playerView/${sessionID}`
    if(tv) popupUrl += "/table"
    window.open(popupUrl, 'popupWindow',
    'width=1200,height=800,left=0,top=100');
};

export const getLevelData = (key) => {
    return key in levelData ? levelData[key]['xp'] : '--';
}

export const isProd = window.location.href.includes("dmbuddy.com") 
export const cheaterMode = window.location.href.includes("/cheater")
export const isDev = !isProd && window.location.href.includes("localhost") 

export const backendUrl = isProd
                    ? `https://dm-buddy-svc-359507bf4ad4.herokuapp.com` 
                    : "http://localhost:8081";

export const callBackUrl = isProd
                    ? `https://dm-buddy-svc-359507bf4ad4.herokuapp.com/spotify/callback` 
                    : "https://currently-artistic-fox.ngrok-free.app/spotify/callback";

export const skills_long = ["Strength Score", "Dexterity Score", "Constitution Score", "Intelligence Score", "Wisdom Score", "Charisma Score"];
export const skill_codes = [3520, 3521, 3522, 3523, 3524, 3525];
export const skills_short = ["STR", "DEX", "CON", "INT", "WIS", "CHA"];


export const conditionImgMap = {
    "Blinded Condition": blindedCondition, 
    "Charmed Condition": charmed, 
    "Deafened Condition": deafened,
    "Exhaustion Condition": aid,
    "Frightened Condition": frightened, 
    "Grappled Condition": aid, 
    "Incapacitated Condition": incapacitated,
    "Invisible Condition": invisibleCondition,
    "Paralyzed Condition": paralyzed,
    "Petrified Condition": petrified,
    "Poisoned Condition": poisonedCondition,
    "Prone Condition": aid,
    "Restrained Condition": aid,
    "Stunned Condition": stunned,
    "Unconscious Condition": unconscious,
};

export const effectImgMap = {
    "Aided": aid,
    "Baned": bane, 
    "Blade Ward": bladeWard, 
    "Blessed": bless, 
    "Blinded": blinded, 
    "Bone Chilled": boneChilled, 
    "Bark Skin": barkSkin, 
    "Command": command, 
    "Confused": confused, 
    "Disguised": disguised, 
    "Ensnared": ensnared, 
    "Faerie Fire": faerieFire, 
    "Guidance": guidance, 
    "Guiding Bolt": guidingBolt, 
    "Hexed": hex, 
    "Hold Person": holdPerson, 
    "Hunters Mark": huntersMark, 
    "Invisible": invis, 
    "Poisened": poisoned, 
    "Slowed": rayOfFrost, 
    "Sheild Of Faith": sheildOfFaith, 
    "Silenced": silence, 
    "Slept": slept, 
    "Enwebbed": webbed, 
};

export const LONG_REFRESH = 10
export const SHORT_REFRESH = 1

export const DEFAULT_PREFS = {
    "spotifyAutoPlay": false,
    "useGlobalPvOptions": false,
    "playerViewGlobalOptions": {
        "iconSize": 0,
        "playerOptions": {
            "showHp": false,
            "position": "Center",
            "showDead": true,
            "showSize": true,
            "teamSize": "0",
            "showBlood": true,
            "showHpBar": true,
            "deathSaves": true,
            "showAc": true
        },
        "allyOptions": {
            "showHp": false,
            "position": "Center",
            "showDead": true,
            "showSize": false,
            "teamSize": 0,
            "showBlood": true,
            "showHpBar": false,
            "showName": true,
            "showAc": false
        },
        "monsterOptions": {
            "showHp": false,
            "position": "Center",
            "showDead": true,
            "showSize": false,
            "teamSize": 0,
            "showBlood": true,
            "showHpBar": false,
            "deathSaves": true,
            "showName": true,
            "showAc": false
        },
        "tableViewOptions": {
            "position": "Top,Bottom",
            "teamSize": 0,
            "iconMargin": 0, 
            "mapSize": 0,
            "gridSize": 0, 
            "showGrid": false
        }
    }
}

export const INIT_ENCOUNTER_NAME = 'Name Your Encounter';

export const INIT_ENCOUNTER = {
    encounterName: INIT_ENCOUNTER_NAME,
    encounterGuid: "",
    roundNum: 0,
    turnNum: 0,
    creatures: [],
    backgroundGuid: 'default',
    hideEnemies: true,
    playerViewOptions: DEFAULT_PREFS.playerViewGlobalOptions
}

const combinedMonsters = allJsonData.flatMap(innerArray => {
    const a = innerArray
        .filter(monster => !("_copy" in monster)) // Exclude monsters with the `_copy` key
        .map(monster => monster); // Map the remaining monsters

    return a
});

let combinedArray = [...combinedMonsters.map((m) => { 
        return m.objectType ? tools5eObjectToDmBMapper(m) : tools5eToDmBMapper(m)
    }
)];

const sortedCreatures = combinedArray.slice().sort((a, b) => {
    return a.name.localeCompare(b.name);
});

export const sortedMonsterList = sortedCreatures;
export const reversedMonsterList = [...sortedCreatures].reverse(); 
export const shuffledMonsterList = shuffleArray(combinedArray);

export const imagesAvailable = [
    "5e Core Rules",
    "Tome of Beasts",
    "Critical Role: Tal’Dorei Campaign Setting",
    "Tome of Beasts 2023"
]

export const sizeOptions = [
    '--',
    'Tiny',
    'Small',
    'Medium',
    'Large',
    'Huge',
    'Gargantuan',
];

export const typeOptions = [
    '--',
    'Aberration',
    'Beast',
    'Celestial',
    'Construct',
    'Dragon',
    'Elemental',
    'Fey',
    'Fiend',
    'Giant',
    'Humanoid',
    'Monstrosity',
    'Ooze',
    'Plant',
    'Undead',
    'Siege Weapons'
];

export const alignmentOptions = [
    '--',
    'Lawful Good',
    'Neutral Good',
    'Chaotic Good',
    'Lawful Neutral',
    'True Neutral',
    'Chaotic Neutral',
    'Lawful Evil',
    'Nuetral Evil',
    'Chaotic Evil',
    'Unaligned',
];

export const raceOptions = [
    '--',
    'Aarakocra',
    'Aasimar',
    'Bugbear',
    'Centaur',
    'Changeling',
    'Dragonborn',
    'Dwarf',
    'Dwarf(Duergar)',
    'Dwarf(Hill)',
    'Dwarf(Mountain)',
    'Elf',
    'Elf(Drow)',
    'Elf(Eladrin)',
    'Elf(High)',
    'Elf(Sea)',
    'Elf(Wood)',
    'Firbolg',
    'Genasi',
    'Genasi(Air)',
    'Genasi(Earth)',
    'Genasi(Fire)',
    'Genasi(Water)',
    'Gith',
    'Gnome',
    'Gnome(Deep)',
    'Gnome(Forest)',
    'Gnome(Rock)',
    'Goblin',
    'Goliath',
    'Half-Elf',
    'Half-Orc',
    'Halfling',
    'Halfling(Stout)',
    'Hobgoblin',
    'Human',
    'Human(Variant)',
    'Kalashtar',
    'Kenku',
    'Leonin',
    'Lizardfolk',
    'Loxodon',
    'Minotaur',
    'Orc',
    'Satyr',
    'Shifter',
    'Simic Hybrid',
    'Tabaxi',
    'Tiefling',
    'Triton',
    'Vedalken',
    'Verdan',
    'Warforged',
    'Yuan-Ti'
];

export const creatureTypes = {
    1: 'Aberration',
    2: 'Beast',
    3: 'Celestial',
    4: 'Construct',
    5: 'If you see this please tell me what type this monster is',
    6: 'Dragon',
    7: 'Elemental',
    8: 'Fey',
    9: 'Fiend',
    10: 'Giant',
    11: 'Humanoid',
    12: 'If you see this please tell me what type this monster is',
    13: 'Monstrosity',
    14: 'Ooze',
    15: 'Plant',
    16: 'Undead',
    17: 'Siege Weapons',
}

export const creatureSizes = {
    1: 'If you see this please tell me what type this monster is',
    2: 'Tiny',
    3: 'Small',
    4: 'Medium',
    5: 'Large',
    6: 'Huge',
    7: 'Gargantuan',
}

export const levelData = {
    '0': {'xp': 0, 'profBonus': 2},
    '1/8': {'xp': 25, 'profBonus': 2},
    '1/4': {'xp': 50, 'profBonus': 2},
    '1/2': {'xp': 100, 'profBonus': 2},
    '1': {'xp': 200, 'profBonus': 2},
    '2': {'xp': 450, 'profBonus': 2},
    '3': {'xp': 700, 'profBonus': 2},
    '4': {'xp': 1100, 'profBonus': 2},
    '5': {'xp': 1800, 'profBonus': 3},
    '6': {'xp': 2300, 'profBonus': 3},
    '7': {'xp': 2900, 'profBonus': 3},
    '8': {'xp': 3900, 'profBonus': 3},
    '9': {'xp': 5000, 'profBonus': 4},
    '10': {'xp': 5900, 'profBonus': 4},
    '11': {'xp': 7200, 'profBonus': 4},
    '12': {'xp': 8400, 'profBonus': 4},
    '13': {'xp': 10000, 'profBonus': 5},
    '14': {'xp': 11500, 'profBonus': 5},
    '15': {'xp': 13000, 'profBonus': 5},
    '16': {'xp': 15000, 'profBonus': 5},
    '17': {'xp': 18000, 'profBonus': 6},
    '18': {'xp': 20000, 'profBonus': 6},
    '19': {'xp': 22000, 'profBonus': 6},
    '20': {'xp': 25000, 'profBonus': 6},
    '21': {'xp': 33000, 'profBonus': 7},
    '22': {'xp': 41000, 'profBonus': 7},
    '23': {'xp': 50000, 'profBonus': 7},
    '24': {'xp': 62000, 'profBonus': 7},
    '25': {'xp': 75000, 'profBonus': 8},
    '26': {'xp': 90000, 'profBonus': 8},
    '27': {'xp': 105000, 'profBonus': 8},
    '28': {'xp': 120000, 'profBonus': 8},
    '29': {'xp': 135000, 'profBonus': 9},
    '30': {'xp': 155000, 'profBonus': 9},
    '--': {'xp': 0, 'profBonus': 0}
};



const sharedItems = {
    "from": "dmb",
    "name": "Dummy",
    "name_default": "Dummy",
    "hit_dice": "1d8",
    "hit_points": 1,
    "hit_points_default":  1,
    "hit_points_current": 1,
    "hit_points_temp": 0,
    "hit_points_override": 0,
    "hit_points_modifier": 0,
    "initiative": 0,
    "last_damage": null,
    "effects": [],
    "creatureGuid": null,
    "senses": "",
    "armor_class": 0,
    "damage_vulnerabilities": "",
    "damage_resistances": "",
    "damage_immunities": "",
    "condition_immunities": "",
    "strength": 10,
    "dexterity": 10,
    "constitution": 10,
    "intelligence": 10,
    "wisdom": 10,
    "charisma": 10,
    "strength_save": 0,
    "dexterity_save": 0,
    "constitution_save": 0,
    "intelligence_save": 0,
    "wisdom_save": 0,
    "charisma_save": 0,
    "perception": null,
    "skills": [],
    "spellcasting": [],
    "bonus_actions": [],
    "reactions": [],
    "mythic_desc": "",
    "mythic_actions": [],
    "legendary_desc": "",
    "legendary_actions": [],
    "lair_actions": [],
    "special_abilities": [],
    "creature_type": "--",
    "subtype": "",
    "group": "",
    "alignment": "",
    "document__slug": "",
    "document__title": "DmBuddy Dummy",
    "document__license_url": "",
    "document__url": "",
    "hidden": false,
    "death_saves_failure_count": 0,
    "death_saves_success_count": 0,
    "xp": "--",
    "level": "0"
}

export const dummyDefault = {
    ...sharedItems,
    "hit_points": 20,
    "hit_points_default": 20,
    "hit_points_current": 20,
    "initiative": 0,
    "type": "default",
    "alignment": "ally",
    "border": COLOR_GREEN,
    "desc": "**Commoners** include peasants, serfs, slaves, servants, pilgrims, merchants, artisans, and hermits.",
    "size": "Medium",
    "armor_class": 10,
    "armor_desc": null,
    "speed": {
        "walk": 30
    },
    "languages": "Common",
    "challenge_rating": "0",
    "cr": 0,
    "actions": [
        {
            "name": "Dumb Club",
            "desc": "Melee Weapon Attack: +2 to hit, reach 5 ft., one target. Hit: 2 (1d4) bludgeoning damage.",
            "attack_bonus": 2,
            "damage_dice": "1d4"
        }
    ],
    "page_no": 398,
    "environments": [
        "Hill",
        "Urban",
        "Grassland",
        "Coastal",
        "Forest",
        "Arctic",
        "Desert",
        "Settlement"
    ]
}

export const homebrewTemplate = {
    ...sharedItems,
    "name": "Homebrew Template",
    "name_default": "Homebrew-Template-DmBuddy",
    "hit_points": 20,
    "hit_points_default": 20,
    "hit_points_current": 20,
    "initiative": 0,
    "type": "default",
    "alignment": "enemy",
    "border": COLOR_RED,
    "desc": "",
    "size": "--",
    "armor_class": 10,
    "armor_desc": null,
    "speed": {
        "walk": 30
    },
    "languages": "Common",
    "challenge_rating": "0",
    "cr": 0,
    "actions": [],
    "page_no": 0,
    "environments": [],
    "avatarUrl": "https://www.dndbeyond.com/Content/Skins/Waterdeep/images/icons/monsters/beast.jpg"
}


export const envObject = {
    ...sharedItems,
    "type": "global",
    "alignment": "neutral",
    "border": "#FFFFFF",
    "name": "Env/Lair",
    "name_default": "Env/Lair",
    "desc": "A falling piller, exploding magma, the world is your oyster! And that oyster will blow up at the end of the round. Poor souls...",
    "size": "",
    "armor_desc": null,
    "speed": {
        "walk": 0
    },
    "languages": "Terren",
    "challenge_rating": null,
    "cr": "--",
    "actions": [
        {
            "name": "Super Earth Combo",
            "desc": "Melee Weapon Attack: +100 to hit, reach - are you on earth?, alot of targets. Hit: 5000 (10d100) force damage.",
        }
    ],
    "environments": [
        "Earth",
        "Space?"
    ],
    "avatarUrl": GlobalImg,
}

export function buildNestedFolders(encounters) {
    const root = {};
    encounters.forEach(enc => {
        // Change "Unsorted" to "No Folder"
        const path = enc.folder_dir ? enc.folder_dir.split('/') : ['No Folder'];
        let node = root;
        path.forEach((part, idx) => {
            if (!node[part]) node[part] = { __encounters: [], __children: {} };
            if (idx === path.length - 1) {
                node[part].__encounters.push(enc);
            }
            node = node[part].__children;
        });
    });
    return root;
}

export function filterFolders(folders, searchTerm) {
    if (!searchTerm) return folders;
    const result = {};
    for (const [folder, data] of Object.entries(folders)) {
        const folderMatch = folder.toLowerCase().includes(searchTerm.toLowerCase());
        const filteredEncounters = data.__encounters.filter(enc =>
            enc.encounterName?.toLowerCase().includes(searchTerm.toLowerCase())
        );
        const filteredChildren = filterFolders(data.__children, searchTerm);

        if (folderMatch) {
            // If folder matches, include all its encounters and all its children (unfiltered)
            result[folder] = {
                __encounters: data.__encounters,
                __children: data.__children
            };
        } else if (filteredEncounters.length > 0 || Object.keys(filteredChildren).length > 0) {
            // If any encounters or children match, include only those
            result[folder] = {
                __encounters: filteredEncounters,
                __children: filteredChildren
            };
        }
    }
    return result;
}

export const getDefaultImages = (type) => {
    switch (type) {
        case "aberration":
            return "https://www.dndbeyond.com/Content/Skins/Waterdeep/images/icons/monsters/aberration.jpg";
        case "beast":
            return "https://www.dndbeyond.com/Content/Skins/Waterdeep/images/icons/monsters/beast.jpg";
        case "celestial":
            return "https://www.dndbeyond.com/Content/Skins/Waterdeep/images/icons/monsters/celestial.jpg";
        case "construct":
            return "https://www.dndbeyond.com/Content/Skins/Waterdeep/images/icons/monsters/construct.jpg";
        case "dragon":
            return "https://www.dndbeyond.com/Content/Skins/Waterdeep/images/icons/monsters/dragon.jpg";
        case "elemental":
            return "https://www.dndbeyond.com/Content/Skins/Waterdeep/images/icons/monsters/elemental.jpg";
        case "fey":
            return "https://www.dndbeyond.com/Content/Skins/Waterdeep/images/icons/monsters/fey.jpg";
        case "fiend":
            return "https://www.dndbeyond.com/Content/Skins/Waterdeep/images/icons/monsters/fiend.jpg";
        case "giant":
            return "https://www.dndbeyond.com/Content/Skins/Waterdeep/images/icons/monsters/giant.jpg";
        case "humanoid":
            return "https://www.dndbeyond.com/Content/Skins/Waterdeep/images/icons/monsters/humanoid.jpg";
        case "monstrosity":
            return "https://www.dndbeyond.com/Content/Skins/Waterdeep/images/icons/monsters/monstrosity.jpg";
        case "ooze":
            return "https://www.dndbeyond.com/Content/Skins/Waterdeep/images/icons/monsters/ooze.jpg";
        case "plant":
            return "https://www.dndbeyond.com/Content/Skins/Waterdeep/images/icons/monsters/plant.jpg";
        case "undead":
            return "https://www.dndbeyond.com/Content/Skins/Waterdeep/images/icons/monsters/undead.jpg";
        case "Siege Weapons":
            return objectImage;
        default:
            return "https://www.dndbeyond.com/Content/Skins/Waterdeep/images/icons/monsters/beast.jpg"; 
    }
}

export const getDndBMonsterData = async (name, setBackendReady=undefined) => {
    try {
        const urlName = name.replace(/ /g, '-');
        const url = `${backendUrl}/dndb_get_monster_image/${urlName}`;

        const response = await axios.get(url).then(res => {
            let data = res.data.data
            return data.length > 0 ? data[0] : res
        })

        return response

    } catch (error) {
        console.error('Error fetching filtered creatures:', error);
        if(error.code === "ERR_NETWORK") {
            setBackendReady(false)
        }
    }
};

export const getImageUrl = async (name, type) => {

    let url = getDefaultImages(type);
    if(isDev || type === "Siege Weapons") {
        return url
    }

    try {   
        let creatureData = await getDndBMonsterData(name)
        if(creatureData?.avatarUrl) {
            url = creatureData.avatarUrl
        }
    } catch(error) {
        console.error('Error setting image:', error)
    } finally {
        return url
    }
}